<template>
  <div style="width:100%">
    <el-header  style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>
    <el-main>
      <Table :tableData.sync="tableData" :showSearch="true" :showEdit="true" :showExport="true" :showImport="true" :showEditButton="true"  
             @sync-delete="deleteDongle" @sync-save="saveDongle"/> 
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from "../components/Breadcrumb.vue";
import Table from '../components/EditableTable';

import { apiFindDongleData, apiSaveDongleData, apiDeleteDongleDataById } from "../../utils/api.js";
import authHeader from "../../services/auth-header";


export default {
  name: 'dongleSerialNumber',
  data() {
    return {
      tableData: {
        sel: null,
        columns: [
          { field: "feedDate", title: "Feed Date", width: 150, type:"date", required:true },
          { field: "serialNumber", title: "Dongle Serial No.", width: 170 , required:true, checkFn: this.checkSnFormat },
          { field: "lockingCode", title: "Locking Code", width: 230, required:true, checkFn: this.checkLockCodeFormat  },
          { field: "dongle", title: "Active Code for Dongle", required:true, checkFn: this.checkDongleFormat } //
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'dongleSerialTable',
        exportName: 'dongleSerialNumber'
      },
    };
  },
  components: {
    Breadcrumb,
    Table
  },
  mounted() {    
    this.readData();
  },
  methods: {
    readData(){
      this.tableData.data = [];
      this.tableData.originalTableData =  [];  
      apiFindDongleData({ headers: authHeader() }).then((response) => {               
        this.tableData.data = response.data;
        this.tableData.originalTableData =  this.tableData.data;    
      }).catch((err) => {
        console.log(err);
      });
    },
    saveDongle(data){
 
      if(data.length == null){
        data = [data];
      }
      
      apiSaveDongleData({  headers: authHeader(), dongles : data}).then((response) => {                    
        if(response.status == 200){
          this.readData();
          this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
        }else{          
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }           
      
      }).catch((err) => {
        if(err.response.data.message != null && err.response.data.message != ''){
          this.$message.error({message:err.response.data.message, duration: 1000});
        }else{
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }        
        console.log(err);
      });
    },
    deleteDongle(data){           
      apiDeleteDongleDataById({  headers: authHeader(), deleteId : data.id}).then((response) => {               
        if(response.status == 200){
          this.$message.success({message: this.$i18n.t('msg.deleteSuccess'), duration: 800});
        }else{
          this.$message.error({message: this.$i18n.t('msg.deleteFail'), duration: 800});
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    checkDongleFormat(dongle){
      
      var regex=/^[0-9A-Z]+$/;
      var result = regex.test(dongle);
      console.log('checkDongleFormat dongle :'+dongle+", result:"+result);
      if(!result){
        this.$message.error({message: 'Active Code for Dongle  須為大寫英文或數字', duration: 1000}); 
      }
      return result;
    },
    checkSnFormat(value){
      // DROC + 10碼數字或VETDROC + 10碼數字或VETWS + 10碼數字或NWS + 10碼數字

      var formatArr = ['DROC','VETDROC','VETWS', 'NWS'];
      var re = /^[0-9]+$/;//判斷字串是否為數字//判斷正整數/[1−9] [0−9]∗]∗/     
      var result = false;
      formatArr.forEach(function(item){
        if(value.startsWith(item)){    
          var tempNumber = value.replace(item, '');
          if (tempNumber.length == 10 && re.test(Number(tempNumber))) { 
      　　　 result = true;
      　　}    
        }
      });
      if(!result){
        this.$message.error({message: 'Dongle Serial No. 需為DROC或VETDROC或VETWS或NWS開頭並後面接10碼數字', duration: 1000});
      }
      return result;  
    },
    checkLockCodeFormat(value){
      var regex=/^[0-9A-Z]+$/;
      var result = regex.test(value);
      console.log('checkLockCodeFormat value :'+value+", result:"+result);
      if(!result){
        this.$message.error({message: 'Locking Code 須為大寫英文或數字', duration: 1000});
      }
      return result;
    }                               
  },
  
};
</script>